module.exports = __webpack_public_path__ + "static/img/page45.43115cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page45.jpg
// module id = pDsQ
// module chunks = 0